import React, { useEffect, useState } from 'react';
import Spinner from '../../../spinner';
import { Button, Col, Table, Row, Tabs } from 'antd';
import NotificationMessage from "../../../modals/notification-message";
import { useFetchNotification } from "../../../../hooks/use-fetch-notification";
import { companyService } from "../../../../services";
import EtrnLegalEntities from './etrn';
import EdoLegalEntities from './edo';

export default function CarPark() {
	const [loading, setLoading] = useState(false);
	const [stopListUpdate, setStopListUpdate] = useState(false);

	const [{ notifications }] = useFetchNotification(true);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [companyId, setCompanyId] = useState(null);

	useEffect(() => {
		if (!dataLoaded) {
			setLoading(true);
			companyService.getCompanyId().then((response) => {
					setCompanyId(response);
					setDataLoaded(true);
					setLoading(false);
				})
		}
	}, [dataLoaded]);

	const { TabPane } = Tabs;
	function callback(key) {
	}

	return (
		<React.Fragment>
			<NotificationMessage notifications={notifications} setStopListUpdate={setStopListUpdate} loading={false} />
			<Col span={24}>
				<Spinner loading={loading} tip="Загрузка...">
					<Tabs defaultActiveKey="1" onChange={callback}>
						<TabPane tab="ЭДО" key="1">
							<EdoLegalEntities />
						</TabPane>
						<TabPane tab="ЭТРН" key="2">
							<EtrnLegalEntities />
						</TabPane>
					</Tabs>
				</Spinner>
			</Col>
		</React.Fragment>
	);
}
